(() => {
  const initHeader = (header) => {
    const toggle = header.querySelector('[data-cn-menu-toggle]');
    const panel = header.querySelector('[data-cn-mobile-panel]');
    if (!toggle || !panel || header.dataset.cnReady === 'true') return;

    const firstAction = panel.querySelector('input, a, button');
    const desktopQuery = window.matchMedia('(min-width: 781px)');
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const megaItems = Array.from(header.querySelectorAll('[data-cn-mega-item]'));

    const updateMegaOffset = () => {
      header.style.setProperty('--cn-mega-top', `${Math.round(header.getBoundingClientRect().bottom)}px`);
    };

    const closeMegaMenus = ({ except = null, restoreFocus = false } = {}) => {
      megaItems.forEach((item) => {
        if (item === except) return;
        const wasOpen = item.open;
        item.open = false;
        item.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        if (restoreFocus && wasOpen) item.querySelector(':scope > summary')?.focus();
      });
    };

    const openMegaMenu = (item) => {
      if (!desktopQuery.matches) return;
      updateMegaOffset();
      closeMegaMenus({ except: item });
      item.open = true;
      item.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
    };

    megaItems.forEach((item) => {
      const summary = item.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', item.open ? 'true' : 'false');

      item.addEventListener('pointerenter', () => {
        if (hoverQuery.matches) openMegaMenu(item);
      });

      item.addEventListener('focusin', () => openMegaMenu(item));
      item.addEventListener('toggle', () => {
        summary?.setAttribute('aria-expanded', item.open ? 'true' : 'false');
        if (item.open) closeMegaMenus({ except: item });
      });
    });

    header.querySelectorAll('[data-cn-mega-category]').forEach((category) => {
      const activateCategory = () => {
        const menu = category.closest('.cn-products-menu');
        if (!menu) return;
        const key = category.dataset.cnMegaCategory;
        menu.querySelectorAll('[data-cn-mega-category]').forEach((link) => {
          link.classList.toggle('is-active', link === category);
        });
        menu.querySelectorAll('[data-cn-mega-product-group]').forEach((group) => {
          const active = group.dataset.cnMegaProductGroup === key;
          group.hidden = !active;
          group.classList.toggle('is-active', active);
        });
      };

      category.addEventListener('pointerenter', activateCategory);
      category.addEventListener('focus', activateCategory);
    });

    const closeMenu = ({ restoreFocus = false } = {}) => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      if (restoreFocus) toggle.focus();
    };

    const openMenu = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      firstAction?.focus();
    };

    header.dataset.cnReady = 'true';
    toggle.addEventListener('click', () => {
      if (toggle.getAttribute('aria-expanded') === 'true') closeMenu();
      else openMenu();
    });

    header.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (toggle.getAttribute('aria-expanded') === 'true') closeMenu({ restoreFocus: true });
      closeMegaMenus({ restoreFocus: true });
    });

    document.addEventListener('click', (event) => {
      if (toggle.getAttribute('aria-expanded') === 'true' && !header.contains(event.target)) closeMenu();
      if (!header.contains(event.target)) closeMegaMenus();
    });

    header.querySelector('.cn-desktop-nav')?.addEventListener('mouseleave', () => {
      if (hoverQuery.matches) closeMegaMenus();
    });

    desktopQuery.addEventListener('change', (event) => {
      if (event.matches) closeMenu();
      else closeMegaMenus();
    });

    window.addEventListener('resize', updateMegaOffset, { passive: true });
    window.addEventListener('scroll', updateMegaOffset, { passive: true });
    updateMegaOffset();
  };

  const updateCartHeader = (itemCount) => {
    document.querySelectorAll('.cn-cart-link').forEach((link) => {
      let badge = link.querySelector('.cn-cart-count');
      if (itemCount > 0 && !badge) {
        badge = document.createElement('span');
        badge.className = 'cn-cart-count';
        link.appendChild(badge);
      }
      if (badge) {
        badge.textContent = String(itemCount);
        badge.hidden = itemCount === 0;
      }
      link.setAttribute('aria-label', `Cart with ${itemCount} items`);
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-cn-header]').forEach(initHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise?.then(({ cart, detail }) => {
      if (detail?.didError) return;
      updateCartHeader(cart?.totalQuantity ?? detail?.itemCount ?? 0);
    }).catch(() => {});
  });
})();
